import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { ButtonLink, Icon } from '@/components/ui';

export function RouteError() {
  const error = useRouteError();
  // Un chunk de route introuvable après une mise à jour : on recharge une fois.
  const chunkFailed = error instanceof Error && /dynamically imported module|Importing a module script failed|Failed to fetch/i.test(error.message);
  if (chunkFailed && navigator.onLine && !sessionStorage.getItem('zl-chunk-reload')) {
    sessionStorage.setItem('zl-chunk-reload', '1');
    window.location.reload();
    return null;
  }
  const offline = chunkFailed && !navigator.onLine;
  return (
    <div className="mx-auto max-w-md px-6 py-16 text-center">
      <div className="flex justify-center text-brand-800" aria-hidden="true">
        <Icon name={offline ? 'offline' : 'compass'} size={48} />
      </div>
      <h1 className="mt-4 text-2xl font-bold text-brand-900">{offline ? 'Page non disponible hors ligne' : 'Une erreur est survenue'}</h1>
      <p className="mt-2 text-gray-600">
        {offline ? 'Cette page n’a pas encore été ouverte avec une connexion.' : isRouteErrorResponse(error) ? error.statusText : 'Nous n’avons pas pu afficher cette page.'}
      </p>
      <ButtonLink to="/" className="mt-6">
        Retour à l’accueil
      </ButtonLink>
    </div>
  );
}
